import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './logo.png';
import axios from 'axios';
import useLocalStorageState from 'use-local-storage-state';
import Spinner from 'react-bootstrap/Spinner';

const Login = () => {
  const [token, setToken] = useLocalStorageState('token', '');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailerr, setEmailerr] = useState('');
  const [passerr, setPasserr] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const checkAuthentication = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const userIsAuthenticated = localStorage.getItem('token') ? true : false;
        resolve(userIsAuthenticated);
      }, 1500);
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setPasserr('');
    setEmailerr('');
    setLoading(true);

    let endpoint = process.env.REACT_APP_PHP_URL + 'login';
    const formData = { email, password };

    try {
      const res = await axios.post(endpoint, formData);
      setToken(res.data.token);
    } catch (error) {
      localStorage.clear();
      if (error.response?.data?.error === 'Invalid Password') {
        setPasserr(error.response.data.error);
      } else if (error.response?.data?.message?.email === undefined) {
        setPasserr(error.response?.data?.message?.password?.[0] || 'Invalid credentials');
      } else {
        setEmailerr(error.response?.data?.message?.email?.[0] || 'Invalid credentials');
      }
      setLoading(false);
    } 
  };

  useEffect(() => {
    const fetchAuthStatus = async () => {
      const authStatus = await checkAuthentication();
      setIsAuthenticated(authStatus);
      setLoading(false);
    };

    fetchAuthStatus();
  }, []);

  if (loading) {
    return (
      <div style={{ paddingTop: '200px' }}>
        <center>
          <Spinner animation="grow" variant="primary" />
          <Spinner animation="grow" variant="secondary" />
          <Spinner animation="grow" variant="success" />
          <Spinner animation="grow" variant="danger" />
          <Spinner animation="grow" variant="warning" />
          <Spinner animation="grow" variant="info" />
          <Spinner animation="grow" variant="light" />
          <Spinner animation="grow" variant="dark" />
        </center>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-3" />
        <div className="col-sm-6">
          <br />
          <div className="card">
            <div className="card-body form">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <img src={logo} alt="Logo" className="center" />
                  <br />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    required
                    className={`form-control ${emailerr ? 'is-invalid' : ''}`}
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <div className="invalid-feedback">{emailerr}</div>
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <input
                    type="password"
                    required
                    autoComplete="off"
                    className={`form-control ${passerr ? 'is-invalid' : ''}`}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <div className="invalid-feedback">{passerr}</div>
                </div>
                <button type="submit" className="loginbtn btn btn-primary">
                  Login
                </button>
                <br /><br />
                <center><a href="/forgotpassword">Forgot password</a></center>
                <br />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
